import { Curl } from "components/Jarvis";
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimeRangeTransaction = (fromdate, todate) => {
  if (!fromdate || !todate) {
    const newData = {
      timezone: timezone,
      fromdate: 90,
      todate: null,
    };
    return Curl.post(
      `/payplus/gateway/resources/getTimeRangeTransactions`,
      newData
    ).then((res) => {
      return res;
    });
  } else {
    const newData = {
      timezone: timezone,
      fromdate: fromdate,
      todate: todate,
    };
    return Curl.post(
      `/payplus/gateway/resources/getTimeRangeTransactions`,
      newData
    ).then((res) => {
      return res;
    });
  }
};

export const getSumTransaction = () => {
  const newData = {
    timezone: timezone,
  };
  return Curl.post(`/payplus/gateway/resources/sumTransactions`, newData).then(
    (res) => {
      return res;
    }
  );
};

export const getPaymentReceipt = (id) => {
  return Curl.get(
    `/payplus/payment/${id}/receipt?print=false&isPortal=true`
  ).then((res) => {
    return res;
  });
};
